import {
  EuiButton,
  EuiButtonEmpty,
  EuiCallOut,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
} from "@inscopix/ideas-eui";
import { useState } from "react";
import { useDataTableContext } from "../store/DataTableProvider";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";

import {
  FileAssignmentsWarning,
  useFilesToDeleteForCellRanges,
} from "./FileAssignmentsWarning";

interface ModalDeleteColumnProps {
  columnId: string;
  onClose: () => void;
  tableId: string;
}

export const ModalDeleteColumn = ({
  columnId,
  onClose,
  tableId,
}: ModalDeleteColumnProps) => {
  const deleteDataTableColumn = useDataTableContext(
    (s) => s.deleteDataTableColumn,
  );
  const files = useFilesToDeleteForCellRanges({ columnId });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    const { error } = await deleteDataTableColumn({
      tableId,
      columnId,
      fileIds: files.map((f) => f.id),
    });
    setIsLoading(false);

    if (error === undefined) {
      addUtilityToastSuccess("Column deleted");
    } else {
      addUtilityToastFailure("Failed to delete column");
    }

    onClose();
  };

  return (
    <EuiModal onClose={onClose}>
      <EuiModalHeader>
        <EuiModalHeaderTitle component="h3">Remove Column</EuiModalHeaderTitle>
      </EuiModalHeader>
      <EuiModalBody>
        <EuiCallOut
          title="Proceed with caution!"
          color="warning"
          iconType="warning"
        >
          <p>
            Cells in the removed column may be referenced in other tables.
            Removing this column might cause unwanted changes to your data.
          </p>

          {files.length > 0 && <FileAssignmentsWarning files={files} />}
        </EuiCallOut>
      </EuiModalBody>
      <EuiModalFooter>
        <EuiButtonEmpty onClick={onClose}>Cancel</EuiButtonEmpty>
        <EuiButton
          isLoading={isLoading}
          fill
          color="danger"
          onClick={() => void handleSubmit()}
        >
          Remove
        </EuiButton>
      </EuiModalFooter>
    </EuiModal>
  );
};
